<template>
  <a-select v-model:value="selected" :options="options" @select="onSelect" style="width: 100px">
  </a-select>
  <a-time-range-picker v-model:value="times" @change="onChange" v-if="selected === 60" :second-step="60"
    :minute-step="10" class="custom-pick no-time" />
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import { ref } from 'vue'

defineProps<{
  timerange?: string[]
}>()
const emits = defineEmits(['update:timerange'])

const options = [
  { label: '不限', value: 0 },
  { label: '午市', value: 5 },
  { label: '晚市', value: 6 },
  { label: '自定义', value: 60 },
]
const date = dayjs().format('YYYY-MM-DD') + ' '
const noon = JSON.parse($app.dic.storeTime.info).noon
const afternoon = JSON.parse($app.dic.storeTime.info).afternoon
const selected = ref(options[0].value)
const times = ref(noon.map(a => dayjs(date + a)))

const onSelect = () => {
  if (selected.value === 60) {
    return
  }
  if (selected.value === 0) {
    emits('update:timerange', null)
    return
  }
  let arr = []
  if (selected.value === 5) arr = noon
  else if (selected.value === 6) arr = afternoon
  else if (selected.value === 0) {
    emits('update:timerange', null)
    return
  }
  times.value = arr.map(a => dayjs(date + a))
  emits('update:timerange', arr)
}

const onChange = () => {
  emits('update:timerange', times.value.map(a => a.format('HH:mm:ss')))
}



</script>
<style scoped lang="scss">
.custom-pick {
  margin-left: 10px;
  width: 350px;

  &.no-time {
    width: 240px
  }

}
</style>